import React, { useState } from "react";
import { Popover } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";

import RpSvgIconBase from "@/components/icons/RpSvgIcon";

type PauseLocationAddIconProps = {
  campaignId?: string | number;
  campaign?: {
    pause_campaign_available?: boolean | null;
  };
  style?: React.CSSProperties;
  className?: string;
};

const RpSvgIcon = RpSvgIconBase as React.ComponentType<any>;

const PauseLocationAddIcon = ({
  campaignId,
  campaign,
  style,
  className,
}: PauseLocationAddIconProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUpdateStatus = () => {
    navigate(`/campaign-pause/${campaignId}`, {
      state: {
        campaign_pause: campaign?.pause_campaign_available || null,
      },
    });

    handleClose();
  };

  const iconStyle = { width: 22, height: 22, ...style };

  return (
    <div>
      <button
        type="button"
        aria-label="Others"
        onClick={handleClick}
        style={{
          ...iconStyle,
          background: "transparent",
          border: 0,
          padding: 0,
        }}
        className={`cursor-p mb-1 ${className || ""}`}
      >
        <RpSvgIcon name="three_dots" title="Others" style={iconStyle} />
      </button>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        disableScrollLock={true}
      >
        <div className="pause-campaign-popover">
          <div
            className="d-flex align-items-center rounded hover-bg cursor-p p-2"
            onClick={handleUpdateStatus}
          >
            <EditIcon
              className="text-secondary"
              fontSize="small"
              color="action"
            />
            <span className="small fw-sb m-0 title">Update Status</span>
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default PauseLocationAddIcon;
